import * as React from "react";
import Box from "@mui/material/Box";
import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import RestoreIcon from "@mui/icons-material/Restore";
import FavoriteIcon from "@mui/icons-material/Favorite";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { useLocation, useNavigate } from "react-router-dom";
import HomeIcon from '@mui/icons-material/Home';
import StoreIcon from '@mui/icons-material/Store';
import EmojiPeopleIcon from '@mui/icons-material/EmojiPeople';
import BusinessIcon from '@mui/icons-material/Business';
import MopedIcon from '@mui/icons-material/Moped';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import InventoryIcon from '@mui/icons-material/Inventory';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import SearchIcon from '@mui/icons-material/Search';
import { UserType } from '../../../enums/users';
import LabelIcon from '@mui/icons-material/Label';
import SettingsIcon from '@mui/icons-material/Settings';
import ListAltIcon from '@mui/icons-material/ListAlt';
import InboxIcon from '@mui/icons-material/Inbox';
export const drawerWidth = '275px';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import SortIcon from '@mui/icons-material/Sort';
import ReceiptIcon from '@mui/icons-material/Receipt';
import { DeliveryDining } from '@mui/icons-material';
import { MenuDefinitionItem } from "../side-nav/side-nav.config";
import { user_is_driver } from "../../../utils/permissions";

const driver_menu_definition: MenuDefinitionItem[] = [
    {
        name: 'Home',
        icon: <HomeIcon />,
        route_substring: 'home',
        route: 'home',
        isVisible: user_is_driver,
    },
    {
        name: 'Pickup',
        icon: <InboxIcon />,
        route_substring: 'pickup-tasks',
        route: 'pickup-tasks',
        isVisible: user_is_driver,
    },
    {
        name: 'Delivery',
        icon: <DeliveryDining />,
        route_substring: 'delivery-batches',
        route: 'delivery-batches',
        isVisible: user_is_driver,
    },
    {
        name: 'Payment',
        icon: <AttachMoneyIcon />,
        route_substring: 'payment-tasks',
        route: 'payment-tasks',
        isVisible: user_is_driver,
    },
    {
        name: 'Invoices',
        icon: <ReceiptIcon />,
        route_substring: 'invoice',
        route: 'invoices',
        isVisible: user_is_driver,
    },
];


export default function SimpleBottomNavigation() {
    const location = useLocation();
    const navigate = useNavigate();

    // Determine current tab based on current URL
    const currentIndex = driver_menu_definition.findIndex(item =>
        location.pathname.includes(item.route_substring)
    );

    const [value, setValue] = React.useState(currentIndex === -1 ? 0 : currentIndex);

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
        navigate(`/${driver_menu_definition[newValue].route}`);
    };

    return (
        <Box
            sx={{
                width: "100vw",
                position: "fixed",
                bottom: 0,
                left: 0,
                zIndex: 1000,
                boxShadow: "0 -1px 5px rgba(0,0,0,0.1)",
            }}
        >
            <BottomNavigation value={value} onChange={handleChange} showLabels>
                {driver_menu_definition.map((item, index) => (
                    <BottomNavigationAction
                        key={index}
                        label={item.name}

                        icon={item.icon}
                        sx={{
                            minWidth: 30,
                            px: 0,
                            mx: 0,
                        }}
                    />
                ))}
            </BottomNavigation>
        </Box>
    );
}
